export default __webpack_public_path__ + "static/media/cuvette_rack_extra_short.37d5c6c2.svg";